export default import.meta.ROLLDOWN_FILE_URL_Mwo_GwWh1QhSu8GaPk3Sig